import { createContext, useContext, useState } from 'react';

const NotificationContext = createContext({});

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([
    { id: 1, title: 'New Arrival: Premium Jersey', message: 'Limited edition available now!', read: false, time: '2 mins ago' },
    { id: 2, title: 'Order Shipped', message: 'Your order #1234 is on the way', read: false, time: '1 hour ago' },
    { id: 3, title: 'Best Seller Alert', message: 'Training shorts back in stock!', read: true, time: '5 hours ago' },
    { id: 4, title: 'Welcome to CAB Store', message: '10% off your first purchase', read: true, time: '2 days ago' },
  ]);

  const unreadCount = notifications.filter(n => !n.read).length;

  const markAsRead = (id) => {
    setNotifications(prev => prev.map(n => 
      n.id === id ? { ...n, read: true } : n
    ));
  };

  const clearAll = () => {
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  };

  const value = {
    notifications,
    unreadCount,
    markAsRead,
    clearAll,
  };

  return (
    <NotificationContext.Provider value={value}>
      {children}
    </NotificationContext.Provider>
  );
};
